import React from "react";
import * as Yup from "yup";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";

// form
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// @mui
import {
  Stack,
  Typography,
  TextField,
  MenuItem,
  Grid,
  Box
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components

import {
  FormProvider,
  RHFTextField,
} from "../../../components/hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import RHFTextEditor from "../../../components/hook-form/RHFTextEditor";
import { useTheme } from "@emotion/react";
import { convertYoutubeUrlToEmbed } from "../../../utils/convertYoutubeUrlToEmbed";
import AsyncSelect from 'react-select/async';
import Select from "react-select";

const EditMultipleLecture = () => {
  const theme = useTheme()
  const navigate = useNavigate();
  const [focus, setFocused] = React.useState(false);
  const [resources, setResources] = React.useState(false);
  const [loading, setLoading] = useState(false);

  const [subjectList, setSubjectList] = React.useState([]);
  const[socketUrl , setSocketUrl] = useState("");
  const [fetchMessage, setFetchMessage] = useState();
  const [starting, setStarting] = React.useState(dayjs());
  const [ending, setEnding] = React.useState(dayjs());
  const [validateYoutubeUrl, setValidateUrl] = useState(false);

  const handleChange = (newValue) => {
    setStarting(newValue);
  };
  const handleChangeTwo = (newValue) => {
    setEnding(newValue);
  };

  const LoginSchema = Yup.object().shape({
    lecture_title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    lecture_type: Yup.string().required('Lecture Type is required'),
    LiveOrRecorded: Yup.string().when("lecture_type" , ( lecture_type , Schema) => {
      if( lecture_type != 'TWOWAY'){
        return Schema.required('Type is Required')
      }
    }),
    // subject_id: Yup.string().required("Subject  required"),
    // teacher:Yup.string().required("Teacher  required"),
    language: Yup.string().required("language  required"),
    isActive:Yup.boolean().required("Status Required")
  });

  const defaultValues = {
    lecture_type: "",
    lecture_title: "",
    description: "",
    subject_id: "",
    language: "",
    remember: true,
    link: "",
    isActive : '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { isSubmitting },
  } = methods;

  const [file, setFile] = useState();

  function matchYoutubeUrl(url) {
    var p = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|live\/|v\/)?)([\w\-]+)(\S+)?$/;
    var matches = url.match(p);
    if (matches) {
      // console.log("heeee");
      setValidateUrl(true);
      // setUtubeurl(embedUrl);
      return true;
    }
    return false;
  }

  function matchM3U8Url(url) {
    var p = /\.m3u8/
    var isValid = p.test(url);
    if (isValid) {
      setValidateUrl(true);
      return true;
      // .m3u8
    }
    return false;
  }
  const [utubeurl, setUtubeurl] = useState("");

  const check = () => {
    
    if( youtubeStatus != "APP"){
      var id = matchYoutubeUrl(utubeurl);
     if (id != false) {
      setValidateUrl(true);
      
     } else {
      setValidateUrl(false);
      
     }
    }else{
      let isM3U8 = matchM3U8Url(utubeurl);
      if( isM3U8){
        setValidateUrl(true);
      }else{
        setValidateUrl(false);
      }

      // setValidateUrl(true)
    }
  }

  const changeHandler = async (event) => {
    setFile(event.target.files[0]);
  };
  const [file2 , setFile2] = useState();

  const changeHandler2 = async(event) => {
    setFile2(event.target.files[0]);
  }
  const[file3 , setFile3] = useState();
  const [val, setVal] = useState(false)
  
  const changeHandler3 = (e) => {
    setFile3(e.target.files[0])
  }
  const setUrl = async(event) =>{
    setUtubeurl(event.target.value);
  }
  let formatDate = (date) => {
    let datehelper = "" + date;
    datehelper = datehelper.split(" ");
    let monthsList = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let time = datehelper[4];
    let year = datehelper[3];
    let month = `0${monthsList.indexOf(datehelper[1]) + 1}`.slice(-2);
    let day = datehelper[2];

    return `${day}-${month}-${year} ${time}`;
  };

  
 
  const [liveStatus, setLiveStatus] = useState("");
  const [youtubeStatus, setYoutubeStatus] = useState("");
  const[teacherList , setTeacherList] = useState([]);
 
  const [youtubeVideo, setYoutubeVideo] = useState(false);
  const[searchText , setSearchText] = useState("");
  const [selectedLectures , setSelectedLectures]= useState([]);
  const[lectureList , setLectureList] =  useState([]);
  const[selectedSubject , setSelectedSubject] =  useState();
  const[selectedTeacher , setSelectedTeacher] =  useState();


  const handleValueChange1 = (newData) => {
    setSelectedLectures(newData);
  }
  const handleValueChange2 = (newData) => {
    setSelectedSubject(newData);
  }
  const handleValueChange3 = (newData) => {
    setSelectedTeacher(newData);
  }

  const fetchLecture = async (inputValue) => {
    const token = localStorage.getItem("token");
    const fullResponse = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminSection/fetchLectures?text=${inputValue}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseJson = await fullResponse.json();
      setLectureList(responseJson.data?.lectures);
      setTeacherList(responseJson.data?.teachers);
      setSubjectList(responseJson.data?.subjects);
      return responseJson.data?.lectures;
  }
  const loadOptions = ( inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(fetchLecture(inputValue));
      }, 1000);
    })
  
    

  }

  const onSubmit = async (data) => {
    let StartingDate = formatDate(starting.$d);
    let EndingDate = formatDate(ending.$d);

    if (!youtubeVideo || (validateYoutubeUrl || youtubeStatus == 'TWOWAY')) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      if(file2){
        formData.append("file2" , file2);
      }
      if(file3){
        formData.append("file3" , file3);
      }
      formData.append('lectures' , "");
      formData.append('lectures' , "");
      selectedLectures?.map((item) => formData.append('lectures' ,item?.value ));


      formData.append("lecture_type", data.lecture_type);
      formData.append("lecture_title", data.lecture_title);
      formData.append("description", data.description);
      // formData.append("description", description);
      formData.append("language", data.language);
      if (youtubeVideo) {
        let link = utubeurl;
        if( youtubeStatus != "APP"){
          link = utubeurl ? convertYoutubeUrlToEmbed(utubeurl) : utubeurl;
        }
        // console.log(link);
        formData.append("link",link);
      } else {
        formData.append("link", "");
      }

      if (youtubeVideo) {
        formData.append("LiveOrRecorded",youtubeStatus == 'TWOWAY' ? 'Live' : data.LiveOrRecorded);
      } else {
        formData.append("LiveOrRecorded", "Live");
      }

      formData.append("subject_id", selectedSubject?.value);
    //   formData.append("batch_id", Id);
      formData.append("starting_date", StartingDate);
      formData.append("ending_date", EndingDate);
      formData.append("teacher" , selectedTeacher?.value);
      formData.append('isActive' , data.isActive)
      formData.append('socketUrl' , 'https://twoway-backend-prod.sdcampus.com/mediasoup');
      // formData.append("teacher" , "")
      const YtLiveToken = localStorage.getItem("YtLiveToken");

      const token = localStorage.getItem("token");
      const authToken = token;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      };

      axios.put(
          `${process.env.REACT_APP_LIVE_URL}/adminSection/updateAllCommonLectureDetails`,
          formData,
          config
        )
        .then((response) => {
          //console.log(response.data);
          setFetchMessage();

          if (response.data.status) {
            // setPositive(true)
            setLoading(false);
            toast.success("Added The Lecture Details");
            reset();
            setTimeout(() => {
              navigate(`/dashboard/batches`);
            }, 1000);
          } else {
            toast.error(response.data.msg);
            // reset();
            setLoading(false);
          }
        })
        .catch((e) => {
          //console.log(e);
        });
    }
  };
  return (
    <Grid direction="row" pl={5}>
      <Typography variant="h2" ml={2}>
        Edit Multiple Lectures 
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={3}>
        <Typography variant="h6" ml={2} mb={4}>
          Enter the below required details to create a lecture
        </Typography>
      </Stack>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} sx={{ width: "70%" }}>
           <Box sx={{ width : "100%"}}>
              <AsyncSelect 
                cacheOptions 
                closeMenuOnSelect={false}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti={true}
                value={selectedLectures}
                loadOptions={loadOptions}
                onInputChange={(value) => setSearchText(value)}
                onChange={handleValueChange1}
                defaultOptions={lectureList}
               />
           </Box>
          
        <Stack direction="row"
              spacing={3}
              sx={{ width: "100%", justifyContent: "space-between" }}
        >
          <RHFTextField
            name="lecture_type"
            label="Lecture Type"

            select
          >
            <MenuItem value="YT" onClick={() => { setYoutubeStatus("YT"); setYoutubeVideo(true); }}>YouTube</MenuItem>
            <MenuItem value="APP" onClick={() => { setYoutubeStatus("APP"); setYoutubeVideo(true); }}>App</MenuItem>
            <MenuItem value="TWOWAY" onClick={() => { setYoutubeStatus("TWOWAY"); setYoutubeVideo(true); }}>Two Way Communication</MenuItem>
          </RHFTextField>
          <RHFTextField 
              name="file3"
              onChange={changeHandler3}
              id="file3"
              error={!file3 && val}
              helperText='Image Only ( Maximum allowed size 100KB)'
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              InputProps={{
                  classes: {
                      input: "CustomTextField"
                  }
              }}
              inputProps={{ accept: "image/*" }}
              type =  'file'
          />

        </Stack>
          
 

          <RHFTextField name="lecture_title" label="Title "/>
          

          {/* <RHFTextField
            name="description"
            label="Description "
            multiline
            rows={3}
          /> */}
          <RHFTextEditor name="description" label="Description" />
          

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack
              direction="row"
              spacing={3}
              sx={{ width: "100%", justifyContent: "space-between" }}
            >
              <DateTimePicker
                label="Starting time"
                value={starting.$d}
                onChange={handleChange}
                // name="starting_date"
                renderInput={(params) => (
                  <TextField {...params} sx={{ width: "100%" }} />
                )}
              />
              <DateTimePicker
                label="Ending time"
                value={ending.$d}
                onChange={handleChangeTwo}
                sx={{ color: "black" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: "100%", color: "black" }}
                  />
                )}
              />
            </Stack>
          </LocalizationProvider>

          <Stack direction="row" spacing={3} sx={{width: "100%" }}>
            <RHFTextField name="language" label="Language" select>
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="hi">Hindi</MenuItem>
              <MenuItem value="enhi">Bilingual</MenuItem>
            </RHFTextField>
            <Box sx={{ width : '63%'}}>
            <Select
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              options={subjectList}
              value={selectedSubject}
              placeholder={'Select Subject '}
              onChange={handleValueChange2}

            />
            </Box>
            
             { /* <RHFTextField name="subject_id" label="Subject" select>
              {users?.map((item, index) => {
                return (
                  <MenuItem key={index} value={item._id}>
                    {item.title}
                  </MenuItem>
                );
              })}
            </RHFTextField>
            */}
            
            {
              youtubeStatus != 'TWOWAY' ? ( (youtubeVideo && youtubeStatus == "APP") ? (
                <RHFTextField name="LiveOrRecorded" label="Type" select>
                  <MenuItem value="Live" onClick={() => { setLiveStatus("Live"); }}>Live</MenuItem>
                  <MenuItem value="Recorded" onClick={() => { setLiveStatus("Recorded"); }}>Recorded</MenuItem>
                </RHFTextField>
              ) : (
                <RHFTextField name="LiveOrRecorded" label="Type" select>
                  <MenuItem value="Recorded" onClick={() => { setLiveStatus("Recorded"); }}>Recorded</MenuItem>
                  <MenuItem value="Live" onClick={() => { setLiveStatus("Live"); }}>Live</MenuItem>
                </RHFTextField>
              ) ) :  (
                <></>
              )
            }
          </Stack>
          <Stack
            spacing={3}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <RHFTextField
              id="assi"
              name="materials"
              label="Resources"
              onChange={changeHandler}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              inputProps={{ accept: "application/pdf" }}
              helperText="Pdf Files Only"
              InputProps={{
                classes: {
                  input: "CustomTextField",
                },
              }}
              onClick={() => setResources(true)}
              type={resources || focus ? "file" : "text"}
            />
            <RHFTextField
              id="dpp"
              name="dpp"
              label="DPP"
              onChange={changeHandler2}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              inputProps={{ accept: "application/pdf" }}
              helperText="Pdf Files Only"
              InputProps={{
                classes: {
                  input: "CustomTextField",
                },
              }}
              onClick={() => setResources(true)}
              type={resources || focus ? "file" : "text"}
            />
            
            {youtubeVideo ? (
              ( youtubeStatus != 'TWOWAY') && (<>
                {" "}
                <RHFTextField
                  name="link"
                  label="Link"
                  type="url"
                  // helperText={
                  //   !validateYoutubeUrl ? "Add Valid Youtube Link " : ""
                  // }
                  error={!validateYoutubeUrl}
                  helperText={!validateYoutubeUrl ? "Add Valid Youtube Link" : ""}
                  value={utubeurl}
                  // error={showError ? "" : 'Add Youtube Link'}
                  onChange={setUrl}
                />

              </>)
            ) :
              (<>
              </>)
            }

          </Stack>
          <Stack direction="row" spacing={2} sx={{ width : '100%'}}>
                        <RHFTextField name="isActive" label="Status" type='checkbox' select>
                            <MenuItem value={true}>Active</MenuItem>
                            <MenuItem value={false}>Inactive</MenuItem>
                        </RHFTextField>
                        <Box sx={{ width : '80%'}}>
                            <Select
                               menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                 options={teacherList}
                                 placeholder={'Select Teacher'}
                                 value={selectedTeacher}
                                 onChange={handleValueChange3}

                             />
                         </Box>
                        
                        { /* <RHFTextField name="teacher" label="Teacher" select>
                           {teacherList?.map((item, index) => {
                             return (
                               <MenuItem key={index} value={item._id}>
                                 {item.FullName}
                               </MenuItem>
                             );
                           })}
                         </RHFTextField> 
                        */}

            </Stack>
          
        </Stack>

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={loading}
          onClick={check}
          sx={{
            bgcolor: theme.palette.primary.mainTheme,
            width: "70%",
            marginTop: "5%",
            "&:hover": { background: "red" },
          }}
        >
          Add
        </LoadingButton>
      </FormProvider>
      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* <Typography color={positive ? 'green' : "red"} mt={3} sx={{ textAlign: 'center', width: '70%', textTransform: 'capitalize' }}>{fetchMessage}</Typography> */}
    </Grid>
  );
};

export default EditMultipleLecture;
